<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Filter By Topics</h4>

    <button
      mat-button
      [mat-dialog-close]=""
      (click)="onCancel()"
      cdkFocusInitial
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <div class="buttonbar">
      <button mat-button class="button-close" (click)="selectAllTopics()">
        Select All
      </button>

      <button mat-button class="button-close" (click)="clearAllTopics()">
        Clear All
      </button>
    </div>

    <div class="topics-section">
      <!-- Environment Group -->
      <div class="topic-group">
        <div class="group-header" (click)="toggleGroupExpansion('environment')">
          <mat-icon class="expand-icon">
            {{ expandedGroups.has('environment') ? 'remove' : 'add'
            }}
          </mat-icon>
          <mat-checkbox
            class="group-checkbox"
            [ngModel]="isGroupSelected('environment')"
            (ngModelChange)="toggleGroupSelection('environment', $event)"
            (click)="$event.stopPropagation()"
          >
            Environment
          </mat-checkbox>
        </div>
        <div
          class="group-content"
          [class.expanded]="expandedGroups.has('environment')"
        >
          <div class="topics-container">
            @for (topic of getTopicsByGroup('environment'); track topic) {
            <div class="topic-row">
              <mat-checkbox
                class="filter-country ml-2"
                [ngModel]="isTopicSelected(topic.key.toString())"
                (ngModelChange)="topicChanged({ checked: $event }, topic.key.toString())"
                [disabled]="topic.disabled"
              >
                {{ topic.name }}
              </mat-checkbox>
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Hazardous Materials Group -->
      <div class="topic-group">
        <div
          class="group-header"
          (click)="toggleGroupExpansion('hazardous_materials')"
        >
          <mat-icon class="expand-icon">
            {{ expandedGroups.has('hazardous_materials') ? 'remove' :
            'add' }}
          </mat-icon>
          <mat-checkbox
            class="group-checkbox"
            [ngModel]="isGroupSelected('hazardous_materials')"
            (ngModelChange)="toggleGroupSelection('hazardous_materials', $event)"
            (click)="$event.stopPropagation()"
          >
            Hazardous Materials
          </mat-checkbox>
        </div>
        <div
          class="group-content"
          [class.expanded]="expandedGroups.has('hazardous_materials')"
        >
          <div class="topics-container">
            @for (topic of getTopicsByGroup('hazardous_materials'); track topic)
            {
            <div class="topic-row">
              <mat-checkbox
                class="filter-country ml-2"
                [ngModel]="isTopicSelected(topic.key.toString())"
                (ngModelChange)="topicChanged({ checked: $event }, topic.key.toString())"
                [disabled]="topic.disabled"
              >
                {{ topic.name }}
              </mat-checkbox>
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Health & Safety Group -->
      <div class="topic-group">
        <div
          class="group-header"
          (click)="toggleGroupExpansion('health_safety')"
        >
          <mat-icon class="expand-icon">
            {{ expandedGroups.has('health_safety') ? 'remove' :
            'add' }}
          </mat-icon>
          <mat-checkbox
            class="group-checkbox"
            [ngModel]="isGroupSelected('health_safety')"
            (ngModelChange)="toggleGroupSelection('health_safety', $event)"
            (click)="$event.stopPropagation()"
          >
            Health & Safety
          </mat-checkbox>
        </div>
        <div
          class="group-content"
          [class.expanded]="expandedGroups.has('health_safety')"
        >
          <div class="topics-container">
            @for (topic of getTopicsByGroup('health_safety'); track topic) {
            <div class="topic-row">
              <mat-checkbox
                class="filter-country ml-2"
                [ngModel]="isTopicSelected(topic.key.toString())"
                (ngModelChange)="topicChanged({ checked: $event }, topic.key.toString())"
                [disabled]="topic.disabled"
              >
                {{ topic.name }}
              </mat-checkbox>
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Industry Categories Group -->
      <div class="topic-group">
        <div
          class="group-header"
          (click)="toggleGroupExpansion('industry_categories')"
        >
          <mat-icon class="expand-icon">
            {{ expandedGroups.has('industry_categories') ? 'remove' :
            'add' }}
          </mat-icon>
          <mat-checkbox
            class="group-checkbox"
            [ngModel]="isGroupSelected('industry_categories')"
            (ngModelChange)="toggleGroupSelection('industry_categories', $event)"
            (click)="$event.stopPropagation()"
          >
            Industry Categories
          </mat-checkbox>
        </div>
        <div
          class="group-content"
          [class.expanded]="expandedGroups.has('industry_categories')"
        >
          <div class="topics-container">
            @for (topic of getTopicsByGroup('industry_categories'); track topic)
            {
            <div class="topic-row">
              <mat-checkbox
                class="filter-country ml-2"
                [ngModel]="isTopicSelected(topic.key.toString())"
                (ngModelChange)="topicChanged({ checked: $event }, topic.key.toString())"
                [disabled]="topic.disabled"
              >
                {{ topic.name }}
              </mat-checkbox>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="buttonbar" align="right">
    <div>
      <button
        mat-button
        [disabled]="!hasChanges()"
        (click)="onApply()"
        class="button-close"
        cdkFocusInitial
      >
        Apply
      </button>
      <button
        mat-button
        (click)="onCancel()"
        mat-dialog-close
        class="button-close"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
